import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 14 * 60 + 23;
function format(value: number) {
  return value.toString().padStart(2, '0');
}
export function AnnouncementBar() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSecondsLeft(prev => prev <= 0 ? 0 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  return <div className="w-full bg-brand text-white" data-id="element-15" data-mp="5worldcjaj0u">
      <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2.5 text-center" data-id="element-16" data-mp="walw1yenl5z">
        <HourglassIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-17" data-mp="3s3d80ezdz19c" />

        <p className="font-sans text-[12px] font-bold uppercase tracking-[0.18em]" data-id="element-18" data-mp="1v7xowbrgarxg">
          L&apos;offerta speciale scade tra:
        </p>

        <p className="flex items-baseline gap-1.5 font-sans uppercase" data-id="element-19" data-mp="1q8cpy1ca6jkq">
          <span className="text-[14px] font-extrabold tabular-nums tracking-[0.06em]" data-id="element-20" data-mp="66yqnwzu7fcm">
            {format(minutes)}
          </span>
          <span className="text-[10px] font-bold tracking-[0.14em] text-white/80" data-id="element-21" data-mp="3sfgj6tg2na0i">min</span>
          <span className="text-[13px] font-bold text-white/70" data-id="element-22" data-mp="3sht51hoya4iu">:</span>
          <span className="text-[14px] font-extrabold tabular-nums tracking-[0.06em]" data-id="element-23" data-mp="19fer3qm3enu">
            {format(seconds)}
          </span>
          <span className="text-[10px] font-bold tracking-[0.14em] text-white/80" data-id="element-24" data-mp="txuobaqz54rs">sec</span>
        </p>
      </div>
    </div>;
}